import type { ReservaTaxi, ReservaResponse } from "./types";

/**
 * Crea la reserva a través de nuestro proxy (`/api/reservas-taxi`), que es
 * quien pone la `X-API-KEY`. Desde la actualización el precio no se envía: el
 * servidor lo calcula y lo devuelve en `data.precio`.
 */
export async function postReservaTaxi(
  data: ReservaTaxi,
): Promise<ReservaResponse> {
  try {
    const response = await fetch("/api/reservas-taxi", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = (await response.json()) as ReservaResponse;

    if (!response.ok || !result.success) {
      return {
        success: false,
        message:
          (!result.success && result.message) || `Error ${response.status}`,
        errors: !result.success ? result.errors : undefined,
      };
    }

    return result;
  } catch (error) {
    console.error("Error al enviar reserva de taxi:", error);
    return {
      success: false,
      message:
        error instanceof Error
          ? error.message
          : "Error al enviar la solicitud. Intente nuevamente.",
    };
  }
}
